import Vue from "vue";
import * as rt from "../../../routes/routes";
import * as ers from "../../../errorsmessages/errors";
import * as suc from "../../../successmessages/success";
import * as ses from "../../../configurations/session/sessioncomplete";
import baseurl from "../../../configurations/baseurl/baseurl";
import router from "../../../router";

export const actions = {
  newOccupation({ commit }) {
    let occupationDetail = {
      occupation_name: $(".occupation_name").val()
    };
    $(".creatingOccupation").hide();
    $(".creatingOccupationLoader").show();
    baseurl.post(rt.newOccupation, occupationDetail).then(res => {
      $(".creatingOcupation").hide();
      $(".creatingOccupationLoader").show();

      if (res.data.code === 200) {
        $(".form-control").val("");
        commit("STORE_OCCUPATIONS", res.data.occupations);
        window.$("#new-occupation").modal("hide");
        suc.occupationCreateSuccess();
      } else if (res.data.code === 402) {
        ers.validateErrors();
      } else if (res.data.code === 403) {
        ers.OccupationExists();
      } else if (res.data.code === 404) {
        ers.errorCreatingOccupation();
      } else if (res.data.code === 405) {
        window.$("#new-occupation").modal("hide");
        $(".form-control").val("");
        router.push("/dashboard");
      } else if (res.data.code === 506) {
        $(".form-control").val("");
        window.$("#new-occupation").modal("hide");
        ses.sessionComplete();
      }
    });
  },

  loadOccupations({ commit }) {
    baseurl.get(rt.loadOccupation).then(res => {
      $(".occupationLoader").hide();

      if (res.data.code === 200) {
        commit("STORE_OCCUPATIONS", res.data.occupations);
      } else if (res.data.code === 404) {
        ers.errorLoadingOccupations();
      } else if (res.data.code === 405) {
        ers.noPermissionToRead();
        router.push("/dashboard");
      } else if (res.data.code === 506) {
        ses.sessionComplete();
      }
    });
  },

  viewOccupation({ commit }, occupationId) {
    commit("STORE_OCCUPATION_UPDATE", occupationId);
    window.$("#update-occupation").modal("show");
  },

  updateOccupation({ commit }) {
    let occupationDetails = {
      id: $(".id").val(),
      occupation_name: $(".Uoccupation_name").val()
    };

    $(".updatingOccupation").hide();
    $(".updatingOccupationLoader").show();
    baseurl.post(rt.updateOccupation, occupationDetails).then(res => {
      $(".updatingOccupation").show();
      $(".updatingOccupationLoader").hide();

      if (res.data.code === 200) {
        window.$("#update-occupation").modal("hide");
        suc.occupationUpdateSuccess();
        commit("STORE_OCCUPATIONS", res.data.occupations);
        
      } else if (res.data.code === 402) {
        ers.validateErrors();
      } else if (res.data.code === 404) {
        ers.errorUpdatingOccupation();
      } else if (res.data.code === 405) {
        window.$("#update-occupation").modal("hide");
        ers.noPermissionToUpdate();
        router.push("/manageoccupations");
      } else if (res.data.code === 506) {
        window.$("#update-occupation").modal("hide");
        ses.sessionComplete();
      }
    });
  }
};
export default actions;



// WEBPACK FOOTER //
// ./src/vuex/modules/occupations/actions.js